import { SagaIterator } from "redux-saga";
import { all, call } from "redux-saga/effects";

import { authenticationSagas, initialSetup } from "@montana/containers/authentication/authentication.sagas";
import { cartSagas } from "@montana/containers/cart/cart.sagas";
import { filterSagas } from "@montana/containers/filter/filter.sagas";
import { notificationSagas } from "@montana/containers/notification/notification.sagas";
import { pageSagas, getPageContent } from "@montana/containers/page/page.sagas";
import { productSagas } from '@montana/containers/product/product.sagas';
import { settingsSagas } from '../containers/settings/settings.sagas';
import { siteStructureSagas, onFetchSiteStructure } from "@montana/containers/site-structure/site-structure.sagas";
import { trackingSagas } from "@montana/containers/tracking/tracking.sagas";
import { getTranslations } from "@montana/containers/translations/translations.sagas";
import { checkoutSagas } from "@montana/containers/checkout/checkout.sagas";
import { storesSagas } from "@montana/containers/stores/stores.sagas";


export function* rootSagas(isB2b?: boolean): SagaIterator {
    yield all([
        ...authenticationSagas,
        ...cartSagas(isB2b),
        ...filterSagas,
        ...notificationSagas,
        ...pageSagas,
        ...productSagas,
        ...settingsSagas,
        ...siteStructureSagas,
        ...trackingSagas,
        ...checkoutSagas,
        ...storesSagas,
    ]);
}

const initialLoad = true;
export function* bootstrapSagaB2C(path: string): SagaIterator {
    yield all([
        call(initialSetup),
        call(getTranslations),
        call(getPageContent, path, initialLoad),
        call(onFetchSiteStructure),
    ]);
}

// For the server we only ever want to ask for the page, to determine if it is behind authorization.
// And if not, then nice, just return the page and everything is good.
// We do not care about anything else as the server won't be able to authorize as of now.
export function* bootstrapSagaB2B(path: string): SagaIterator {
    yield call(initialSetup);
    yield call(getTranslations);
    yield call(getPageContent, path, initialLoad);
}
